
const API = "https://ftth.time.net.co/api";

export async function apiFetch(path, opts={}) {
  const r = await fetch(API+path, {credentials:"include",...opts});
  return r.json();
}

export const ROLES = { gerente:"Gerente", administrador:"Administrador", tecnico:"Tecnico", ventas:"Ventas", contabilidad:"Contabilidad" };
export const RC = ["gerente","administrador"];
export const RF = ["gerente","administrador","tecnico"];
export const C = { primary:"#0D4F7C", accent:"#1E7BBF", light:"#F5F7FA", border:"#E8ECF0", text:"#2C2C2C", muted:"#6B7280", white:"#FFFFFF" };
